import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DropZone from 'react-dropzone';
import DocumentForm from './document_form';
import { PERMITTED_EXTENSIONS, MAX_UPLOAD_MB } from '../../constants/documents';
import { getFileExtension } from '../../utils';

class UploadZone extends Component {
  // static PropTypes = {
  //   projectId: PropTypes.string.isRequired,
  //   documentTags: PropTypes.array.isRequired,
  //   onFileUploaded: PropTypes.func.isRequired,
  //   onDrop: PropTypes.func.isRequired,
  //   currentPage: PropTypes.number.isRequired
  // }

    constructor (props) {
        super(props);

        this.state = {
            files: [],
        }

        this.onFileCancel = this.onFileCancel.bind(this);
        this.onFileUploaded = this.onFileUploaded.bind(this);
    }

    onFileUploaded (index) {
        this.props.onFileUploaded(this.props.currentPage);
        this.onFileCancel(index);
    }

    onFileCancel (index) {
        this.setState({
            files: this.state.files.filter((_, i) => i !== index)
        })
    }

    onDrop (files) {
        this.setState({
            files
        });
        this.props.onDrop();
    }

    renderFile (file, i) {
        const key = `${i}-${file.lastModified}`;
        const sizeInMB = Math.round(file.size / 1024 / 1024);
        const extension = getFileExtension(file.name);

        if (PERMITTED_EXTENSIONS.indexOf(extension) === -1) {
            return (
        <div key={key} className="file-error">
          <p>Invalid File Type - <strong>{extension}</strong>. </p>
          <p>Please use one of the permitted file types.</p>
          <button onClick={() => this.onFileCancel(i)}>Close</button>
        </div>
            )
        }

        if (sizeInMB > MAX_UPLOAD_MB) {
            return (
        <div key={key} className="file-error">
          <p>Maximum File Size allowed is {MAX_UPLOAD_MB}MB. </p>
          <p><strong>{file.name} </strong> is approximately {sizeInMB}MB.</p>
          <button onClick={() => this.onFileCancel(i)}>Close</button>
        </div>
            )
        }

        const { projectId, documentTags } = this.props;
        return (
      <DocumentForm
        key={key}
        projectId={projectId}
        file={file} index={i}
        documentTags={documentTags}
        isNewDocument={true}
        onUploaded={this.onFileUploaded}
        onCancel={this.onFileCancel}
      />
        )
    }

    render () {
        const { files } = this.state;

        return (
      <div className="upload-area">
        { files.map((file, i) => this.renderFile(file, i)) }
        { files.length === 0 &&
          <DropZone
            onDrop={this.onDrop.bind(this)}
            className="dropzone"
            activeClassName="dropzone-active"
            rejectClassName="dropzone-reject"
          >
            DROP HERE or CLICK, to add files
          </DropZone>
        }
      </div>
        );
    }
}

UploadZone.propTypes = {
    projectId: PropTypes.string.isRequired,
    documentTags: PropTypes.array.isRequired,
    onFileUploaded: PropTypes.func.isRequired,
    onDrop: PropTypes.func.isRequired,
    currentPage: PropTypes.number.isRequired
};

export default UploadZone;